import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GROUP_TAB_NAME, PAGE_TAB_NAME_LIST, PAGE_TAB_NAME_NEW, PREFERENCE_TAB } from '../../constant';
import { preferenceGroupSaveService } from '../../services/preferenceGroupSaveService';
import { Button } from '@chapche/ui';

const PreferenceGroupSaveButton = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { i18n } = useTranslation();

    const saveNewPreferenceGroup = () => {
        preferenceGroupSaveService.savePreferenceGroup();
        navigate(`/${PREFERENCE_TAB}/${GROUP_TAB_NAME}/${PAGE_TAB_NAME_LIST}`);
    };

    return (
        <Button type="button" className="preference__form-button" onClick={saveNewPreferenceGroup}>
            {id !== PAGE_TAB_NAME_NEW ? i18n.t('app.page.group.edit') : i18n.t('app.page.group.new')}
        </Button>
    );
};

export default PreferenceGroupSaveButton;
